<!-- ===== REFONTE : agenda des activités (apprenant et gestionnaire) ===== -->
<div class="ag-page">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="ag-carte" *ngIf="profilAutorise">
    <!-- En-tête et chiffres -->
    <div class="ag-entete">
      <div>
        <h1 class="ag-titre">{{ titre }}</h1>
        <p class="ag-sous-titre">{{ sousTitre }}</p>
      </div>
      <div class="ag-chiffres" *ngIf="!chargement && !erreurChargement">
        <div class="ag-chiffre">
          <b class="ag-txt-orange">{{ aConfirmerListe.length }}</b
          ><span>à confirmer</span>
        </div>
        <div class="ag-chiffre">
          <b class="ag-txt-vert">{{ nbConfirmees }}</b
          ><span>confirmée(s)</span>
        </div>
        <div class="ag-chiffre">
          <b>{{ nbAVenir }}</b
          ><span>à venir</span>
        </div>
      </div>
    </div>

    <!-- Lien du mail qui ne mène à rien -->
    <div class="ag-alerte ag-alerte--info" role="alert" *ngIf="messageLien">
      <span>{{ messageLien }}</span>
      <button
        type="button"
        class="ag-alerte__fermer"
        aria-label="Fermer"
        (click)="messageLien = null"
      >
        ×
      </button>
    </div>

    <!-- Erreur de chargement -->
    <div
      class="ag-alerte ag-alerte--erreur"
      role="alert"
      *ngIf="erreurChargement"
    >
      <span>{{ messageErreur }}</span>
      <button
        type="button"
        class="ag-btn ag-btn--petit"
        *ngIf="peutReessayer"
        (click)="chargerActivites()"
      >
        Réessayer
      </button>
    </div>

    <!-- Activités qui attendent une confirmation -->
    <div class="ag-bandeau" *ngIf="aConfirmerListe.length as nb">
      <span class="ag-bandeau__icone" aria-hidden="true">⏳</span>
      <span class="ag-bandeau__texte">
        <b
          >{{ nb }} activité{{ nb > 1 ? "s attendent" : " attend" }} votre
          confirmation</b
        >
        <ng-container *ngIf="nb === 1">
          : {{ aConfirmerListe[0].nom }}
          <ng-container *ngIf="aConfirmerListe[0].debut">
            ·
            {{
              aConfirmerListe[0].debut | date: "EEEE d MMMM" : "" : "fr"
            }}</ng-container
          >
        </ng-container>
      </span>
      <button
        type="button"
        class="ag-btn ag-btn--vert"
        (click)="ouvrir(aConfirmerListe[0])"
      >
        {{ nb === 1 ? "Confirmer maintenant" : "Voir la première" }}
      </button>
    </div>

    <!-- Barre : choix de la vue et légende -->
    <div class="ag-barre">
      <div class="ag-segment" role="group" aria-label="Affichage">
        <button
          type="button"
          [class.ag-segment--actif]="vue === 'calendrier'"
          (click)="vue = 'calendrier'"
        >
          Calendrier
        </button>
        <button
          type="button"
          [class.ag-segment--actif]="vue === 'liste'"
          (click)="vue = 'liste'"
        >
          Liste
        </button>
      </div>
      <div class="ag-legende" aria-hidden="true">
        <span><i class="ag-point ag-point--a-confirmer"></i>À confirmer</span>
        <span><i class="ag-point ag-point--confirmee"></i>Confirmée</span>
        <span><i class="ag-point ag-point--en-ligne"></i>En ligne</span>
        <span><i class="ag-point ag-point--a-venir"></i>À venir</span>
        <span><i class="ag-point ag-point--passee"></i>Passée / fermée</span>
      </div>
    </div>

    <div class="ag-chargement" *ngIf="chargement">
      <span class="ag-rond" aria-hidden="true"></span>
      Chargement de vos activités…
    </div>

    <!-- ===== Vue Calendrier ===== -->
    <div class="ag-calendrier" *ngIf="!chargement && vue === 'calendrier'">
      <full-calendar [options]="calendarOptions">
        <ng-template #eventContent let-arg>
          <ng-container
            *ngIf="activiteDe(arg.event.extendedProps.idActivity) as a"
          >
            <div class="ag-ev__contenu">
              <b class="ag-ev__nom">
                <span *ngIf="statut(a) === 'confirmee'">✓ </span>
                <span *ngIf="statut(a) === 'fermee'">🔒 </span>{{ a.nom }}
              </b>
              <span class="ag-ev__info">
                {{ formatHeure(a.heure)
                }}<ng-container *ngIf="a.adresse">
                  · {{ a.adresse }}</ng-container
                >
              </span>
              <span class="ag-ev__action" *ngIf="statut(a) === 'a-confirmer'"
                >Cliquez pour confirmer</span
              >
              <a
                class="ag-ev__action ag-ev__lien"
                *ngIf="statut(a) === 'en-ligne' && a.lien"
                [href]="a.lien"
                target="_blank"
                rel="noopener"
                (click)="$event.stopPropagation()"
              >
                Rejoindre la réunion
              </a>
            </div>
          </ng-container>
        </ng-template>
      </full-calendar>
    </div>

    <!-- ===== Vue Liste ===== -->
    <div class="ag-liste" *ngIf="!chargement && vue === 'liste'">
      <p class="ag-vide" *ngIf="!activites.length">
        Vous n'avez aucune activité pour le moment.
      </p>

      <ng-container *ngFor="let groupe of groupesAVenir">
        <h2 class="ag-mois">{{ groupe.libelle }}</h2>
        <ng-container *ngFor="let a of groupe.activites; trackBy: trackParId">
          <ng-container
            *ngTemplateOutlet="carteActivite; context: { $implicit: a }"
          ></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="passees.length">
        <h2 class="ag-mois">Passées</h2>
        <ng-container *ngFor="let a of passees; trackBy: trackParId">
          <ng-container
            *ngTemplateOutlet="carteActivite; context: { $implicit: a }"
          ></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- Carte d'une activité (vue Liste) -->
<ng-template #carteActivite let-a>
  <div
    class="ag-item"
    [ngClass]="'ag-item--' + statut(a)"
    [class.ag-item--choisie]="activiteOuverte?.id === a.id"
  >
    <div class="ag-item__date">
      <ng-container *ngIf="a.debut; else sansDate">
        <small>{{ a.debut | date: "EEE" : "" : "fr" }}</small>
        <b>{{ a.debut | date: "d" }}</b>
        <small>{{ a.debut | date: "MMM" : "" : "fr" }}</small>
      </ng-container>
      <ng-template #sansDate><b>?</b></ng-template>
    </div>
    <div class="ag-item__corps">
      <b class="ag-item__nom">{{ a.nom }}</b>
      <span class="ag-item__info">
        <ng-container *ngIf="a.heure"
          >⏰ {{ formatHeure(a.heure) }}</ng-container
        >
        <ng-container *ngIf="a.adresse"> · 📍 {{ a.adresse }}</ng-container>
      </span>
      <span class="ag-tag" [ngClass]="'ag-tag--' + statut(a)"
        ><i class="ag-point" [ngClass]="'ag-point--' + statut(a)"></i
        >{{ libelleStatut(a) }}</span
      >
      <div class="ag-item__actions">
        <button
          type="button"
          class="ag-btn ag-btn--vert"
          *ngIf="statut(a) === 'a-confirmer'"
          (click)="ouvrir(a)"
        >
          ✓ Confirmer
        </button>
        <a
          class="ag-btn ag-btn--primaire"
          *ngIf="statut(a) === 'en-ligne' && a.lien"
          [href]="a.lien"
          target="_blank"
          rel="noopener"
          >Rejoindre</a
        >
        <button type="button" class="ag-btn" (click)="ouvrir(a)">
          Détails
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- ===== Fenêtre de détails (volet bas sur mobile) ===== -->
<div class="ag-overlay" *ngIf="activiteOuverte as a" (click)="fermer()">
  <div
    class="ag-modale"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ag-modale-titre"
    (click)="$event.stopPropagation()"
  >
    <div class="ag-modale__poignee" aria-hidden="true"></div>
    <div class="ag-modale__entete">
      <div class="ag-modale__tags">
        <span class="ag-tag ag-tag--type">{{ libelleType(a) }}</span>
        <span class="ag-tag" [ngClass]="'ag-tag--' + statut(a)"
          ><i class="ag-point" [ngClass]="'ag-point--' + statut(a)"></i
          >{{ libelleStatut(a) }}</span
        >
      </div>
      <button
        type="button"
        class="ag-modale__fermer"
        aria-label="Fermer"
        (click)="fermer()"
      >
        ✕
      </button>
      <h2 id="ag-modale-titre">{{ a.nom }}</h2>
    </div>

    <div class="ag-modale__corps">
      <div class="ag-ligne" *ngIf="a.debut">
        <span class="ag-ligne__icone" aria-hidden="true">📅</span>
        <span class="ag-ligne__libelle">Date</span>
        <b>
          {{ majuscule(a.debut | date: "EEEE d MMMM y" : "" : "fr") }}
          <ng-container *ngIf="!memeJour(a)">
            → {{ a.fin | date: "EEEE d MMMM y" : "" : "fr" }}</ng-container
          >
        </b>
      </div>
      <div class="ag-ligne" *ngIf="a.heure">
        <span class="ag-ligne__icone" aria-hidden="true">⏰</span>
        <span class="ag-ligne__libelle">Heure</span>
        <b>{{ formatHeure(a.heure) }}</b>
      </div>
      <div class="ag-ligne" *ngIf="a.adresse">
        <span class="ag-ligne__icone" aria-hidden="true">📍</span>
        <span class="ag-ligne__libelle">Lieu</span>
        <b
          >{{ a.adresse }} ·
          <a [href]="lienCarte(a.adresse)" target="_blank" rel="noopener"
            >Voir sur la carte</a
          ></b
        >
      </div>
      <div class="ag-ligne" *ngIf="statut(a) === 'en-ligne' && a.lien">
        <span class="ag-ligne__icone" aria-hidden="true">💻</span>
        <span class="ag-ligne__libelle">Lien</span>
        <b
          ><a [href]="a.lien" target="_blank" rel="noopener"
            >Rejoindre la réunion</a
          ></b
        >
      </div>
      <p class="ag-description" *ngIf="a.description">{{ a.description }}</p>

      <!-- Résultat de la confirmation, dans la même fenêtre -->
      <div class="ag-succes" *ngIf="etatConfirmation === 'ok'" role="status">
        <b>✅ Participation confirmée</b>
        <span *ngIf="a.debut"
          >Nous vous attendons
          {{ a.debut | date: "EEEE d MMMM" : "" : "fr" }}.</span
        >
      </div>
      <div
        class="ag-alerte ag-alerte--erreur"
        *ngIf="etatConfirmation === 'erreur'"
        role="alert"
      >
        <span
          >La confirmation n'a pas pu être enregistrée. Réessayez dans un
          instant.</span
        >
      </div>
      <!-- ===== CORRECTIF : le NB du QR code ne concerne que les ateliers Force-N ===== -->
      <div
        class="ag-nb"
        *ngIf="
          a.type === 'ATELIER_FORCEN' &&
          (statut(a) === 'confirmee' || etatConfirmation === 'ok')
        "
      >
        📲 <b>Le jour de l'activité</b>, scannez le QR code affiché sur place
        <ng-container *ngIf="emailUtilisateur"
          >et utilisez <b>{{ emailUtilisateur }}</b></ng-container
        >
        pour valider votre présence.
      </div>
    </div>

    <div class="ag-modale__pied">
      <button
        type="button"
        class="ag-btn"
        (click)="fermer()"
        [disabled]="etatConfirmation === 'envoi'"
        [class.ag-btn--primaire]="statut(a) !== 'a-confirmer'"
      >
        Fermer
      </button>
      <button
        type="button"
        class="ag-btn ag-btn--vert"
        *ngIf="statut(a) === 'a-confirmer'"
        (click)="confirmer()"
        [disabled]="etatConfirmation === 'envoi'"
      >
        <span
          class="ag-rond ag-rond--blanc"
          *ngIf="etatConfirmation === 'envoi'"
          aria-hidden="true"
        ></span>
        {{
          etatConfirmation === "envoi"
            ? "Confirmation…"
            : "✓ Confirmer ma participation"
        }}
      </button>
    </div>
  </div>
</div>
<!-- ===== FIN REFONTE ===== -->
